<template>
	<div>
		<h1 class="alpha heavy center">Reset Your Password</h1>
		<form class="mt-2" @submit.prevent="submit">
			<fieldset>
				<div>
					<div v-if="!success">
						<div class="editorial">
							<p>Enter the email address associated with your account and we'll send you a link to reset your password.</p>
						</div>
						<label class="mt-2"><span>Email </span>
							<div>
								<div v-if="form.errors.get('email')" class="error-block">
									<p v-html="form.errors.get('email')"></p>
								</div>
								<input v-model="form.data.email" type="email"/>
							</div>
						</label>
					</div>
					<template v-else>
						<OutcomeBadge
							:result="true"
							class="center"/>
						<div class="editorial mt-2">
							<p>If the provided email matches an address we have on record, we will send an email containing further instructions for resetting your password.
							</p>
							<p>If you haven't received an email within a few minutes, check your spam or <router-link
								:to="{name: 'password.requestToken'}" @click.prevent="reset()">
								try a different email address.</router-link>
							</p>
						</div>
					</template>
				</div>
			</fieldset>
			<ul v-if="!success" class="actions wide">
				<li>
					<process-button
						:processing="form.processing" class="button button--primary--wide"
						text="Send password reset link"/>
				</li>
			</ul>
		</form>
		<ul class="sub-actions">
			<li>
				<router-link :to="{name: 'login'}" class="heavy">Remembered your password?</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
import OutcomeBadge from "../../../../common/components/OutcomeBadge";

export default {
	components: {
		OutcomeBadge,
	},

	data() {
		return {
			form: this.newForm({
				email: "",
			}).setHttpClient(http(true)).setStore(),
			success: false,
		};
	},

	methods: {
		async submit() {
			this.form.processing = true;
			await http(true).get("sanctum/csrf-cookie");
			await this.form.post(window.location.pathname).then(() => {
				this.success = true;
			});
		},
		reset() {
			this.success = false;
			this.form.reset();
		},
	},
};
</script>
